import { type FC } from 'react';

import styles from './ResourceCard.module.css';

import staricon from '/img/icons/star-small-intro.svg';

interface ResourceCardProps {
  starCount: number;
  image: string;
  current: number;
  total: number;
}

const ResourceCard: FC<ResourceCardProps> = ({
  starCount,
  image,
  current,
  total,
}) => {
  return (
    <div className={styles.card}>
      <img src={image} alt="" className={styles.image} />
      <div className={styles.star}>
        <img src={staricon} alt="" />
        <span>{starCount}</span>
      </div>
      <div className={styles.progress}>
        <span className="text-gray-500">{current}</span> / <span>{total}</span>
      </div>
    </div>
  );
};

export default ResourceCard;
